import {TimelineLite} from "gsap";
import 'owl.carousel';

const initHome = () => {

    /*********
     * SLIDERS
     *********/

    $('.js-home-slider').owlCarousel({
        stagePadding: 0,
        items: 1,
        margin: 0,
        pullDrag: false,
        loop: true,
        dots: false,
        singleItem: true,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
        navText: ['&#xf053;', '&#xf054;']
    });

    let owl = $('.js-home-posts');

    const initSlider = (el, options) => {
        el.addClass('owl-carousel').addClass('owl-theme').owlCarousel(options);
    };

    const destroySlider = el => {
        if (el.hasClass('owl-carousel')) {
            el.removeClass('owl-carousel').removeClass('owl-theme').trigger('destroy.owl.carousel');
            el.find('.owl-stage-outer').children(':eq(0)').unwrap();
        }
    };

    function checkSlider (){
        if ($(window).width() < 854) {
            initSlider(owl, {
                items: 1,
                dots: true
            });
        } else {
            destroySlider(owl);
        }
    }

    $(window).resize(function () {
        checkSlider();
    });

    checkSlider

    $('.js-home-places').addClass('owl-carousel').addClass('owl-theme').owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        loop: true,
        dots: true,
        responsive: {
            768: {
                items: 2
            },
            1140: {
                items: 3
            },
            1500: {
                items: 4
            },
            1800: {
                items: 5
            }
        }
    });

    $('.js-home-statistics').addClass('owl-carousel').addClass('owl-theme').owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 3000,
        loop: true,
        dots: true,
        responsive: {
            600: {
                items: 2
            },
            1000: {
                items: 3
            },
            1300: {
                items: 4
            }
        }
    });

    /*********
     * HEADER ANIMATION
     *********/

    const getHeaderAnimation = () => {
        if (window.HeaderTimeline) {
            return window.HeaderTimeline;
        }

        window.HeaderTimeline = new TimelineLite({
            paused: true,
            reversed: true,
            onReverseComplete: () => $('.Header').addClass('Header--home')
        }).from(".Header", 0.2, {
            y: -110,
        });

        return window.HeaderTimeline;
    };

    document.addEventListener('scroll', function () {
        let scrollTop = $(window).scrollTop();

        if (scrollTop >= 800) {
            $('.Header').removeClass('Header--home');
            getHeaderAnimation().play();
        } else {
            getHeaderAnimation().reverse();
        }
    }, true);

};

export default initHome;
